import React from 'react'
import { useLocation } from 'react-router-dom'
import DealReview from '../components/DealReview'

export default function FHDealReview() {
  const { state } = useLocation()
  return <DealReview role="fh" versionId={state?.versionId} proposalId={state?.proposalId} brand={state?.brand} card={state?.card} orderDataFileUri={state?.orderDataFileUri} status={state?.status} />
}
